// Functions meant for the svelte use: directive to operate on the element with legacy bootstrap/jquery functions.

//@ts-ignore
const jq = window.$;

// Queue for batching jquery operations together.
// For example on the calendar, creating and destroying each confirmation/label
// makes the scroll not as smooth.
let queue = []
let queueRunning = false
function runQueue(fn) {
  queue.push(fn)
  if (!queueRunning) {
    queueRunning = true
    setTimeout(()=>{
      queueRunning = false
      for(let f of queue) if (f) f()
      queue = []
    }, 250)
  }
}
function removeQueue(fn) {
  for (let i = 0; i < queue.length; ++i) {
    if (queue[i] == fn) queue[i] = null
  }
}
export function bootstrapConfirmation(node: HTMLElement, {
  onclick,
  oncancel = () => {},
  placement = 'left',
  container = 'body',
  okMessage = 'Delete',
  cancelMessage = 'No',
  btnCancelClass = 'btn btn-xs btn-danger',
  btnOkClass = 'btn btn-xs btn-success',
  btnCancelIcon = 'glyphicon glyphicon-remove',
  btnOkIcon = 'glyphicon glyphicon-ok',
  template = null,
  title = null as (string|null),
  onShow = null
}) {
  let init = false
  const callback = ()=>{
    init = true
    let args = {
      rootSelector: node,
      btnOkClass: btnOkClass,
      btnCancelClass: btnCancelClass,
      btnOkLabel: btnOkIcon != 'glyphicon glyphicon-ok' ? `${btnOkIcon} ${okMessage}` : `<i class="icon-ok-sign icon-white"></i> ${okMessage}`,
      btnCancelLabel: btnCancelIcon != 'glyphicon glyphicon-remove' ? `${btnCancelIcon} ${cancelMessage}` : cancelMessage,
      btnOkIcon: btnOkIcon,
      btnCancelIcon: btnCancelIcon != 'glyphicon glyphicon-remove' ? null : btnCancelIcon,
      placement: placement,
      onConfirm: onclick,
      onCancel: oncancel,
      container: container,
      popout: true,
      singleton: true,
      title
    }
    if (template != null) args.template = template
    jq(node).confirmation(args)
    if (onShow != null) {
      jq(node).on('shown.bs.confirmation', onShow)
    }
  }
  runQueue(callback)
  return {
    destroy() {
      if (init) {
        runQueue(()=>{
          jq(node).confirmation('destroy');
        })
      } else {
        removeQueue(callback)
      }
    }
  }
}

export function bootstrapTooltip(node: HTMLElement, {
  placement = 'top',
  container = 'body',
  title = null as (string|null)
}) {
  let init = false
  const callback = ()=>{
    init = true
    jq(node).tooltip({
      placement: placement,
      container: container,
      popout: true,
      title
    })
  }
  runQueue(callback)
  return {
    destroy() {
      if (init) {
        runQueue(()=>{
          jq(node).tooltip('hide');
        })
      } else {
        removeQueue(callback)
      }
    }
  }
}